import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MsgboxService {
  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  public showSuccess(
    message: string,
    params: Record<string, string | number> = {}
  ): void {
    let _translatedMessage = this.translate.instant(message);
    // Replace placeholders with actual values
    Object.keys(params).forEach((key) => {
      _translatedMessage = _translatedMessage.replace(
        `{{${key}}}`,
        params[key]
      );
    });
    // Show success message
    this.toastr.success(_translatedMessage);
  }

  public showError(
    message: string,
    params: Record<string, string | number> = {}
  ): void {
    let _translatedMessage = this.translate.instant(message);
    console.log({ params });
    // Replace placeholders with actual values
    Object.keys(params).forEach((key) => {
      _translatedMessage = _translatedMessage.replace(
        `{{${key}}}`,
        params[key]
      );
    });
    this.toastr.error(_translatedMessage);
  }
}
